import React, { useState } from "react";
import { BasketFill, ChevronLeft } from "react-bootstrap-icons";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import Style from "./Accardion3.module.scss";
const Accardion3 = () => {
  const [openOnClick, setOpenOnClick] = useState(false);
  const product = [
    {
      id: "1",
      title: "لیست محصولات فروشگاهی",
      link: "/superyProducts",
      active: window.location.pathname === "/superyProducts",
    },

    {
      id: "2",
      title: "ثبت کالا رستورانی",
      link: "/restaurantproduct",
      active: window.location.pathname === "/restaurantproduct",
    },
    {
      id: "3",
      title: " ثبت کالا فروشگاهی",
      link: "/supermarketproduct",
      active: window.location.pathname === "/supermarketproduct",
    },
    {
      id: "4",
      title: "اختصاص کالا رستورانی",
      link: "/assignproducttorestaurant",
      active: window.location.pathname === "/assignproducttorestaurant",
    },
    {
      id: "5",
      title: " اختصاص کالا فروشگاهی",
      link: "/assignproducttosupermarket",
      active: window.location.pathname === "/assignproducttosupermarket",
    },
    {
      id: "6",
      title: "لیست غذاهای رستوران",
      link: "/foodslist",
      active: window.location.pathname === "/foodslist",
    },
  ];
  let value = false;
  product.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });
  const openHandler = () => {
    if (openOnClick) {
      setOpenOnClick(false);
    } else {
      setOpenOnClick(true);
    }
  };
  return (
    <div className={Style.accardionChild}>
      <div
        onClick={openHandler}
        className={
          value || openOnClick ? Style.background : Style.accardionTitle
        }
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}>کالا</p>
          <BasketFill />
        </div>
      </div>
      {product === undefined ? null : (
        <div
          className={
            value || openOnClick ? Style.accardionContent : Style.hidden
          }
        >
          <AccardionItem accardonItem={product && product} />
        </div>
      )}
    </div>
  );
};

export default Accardion3;
